module.exports = __webpack_public_path__ + "static/media/VU.e220447a.png";